import { get, post, patch } from "../web.request";

export const rolePermissionList = async (id) => {
    return await get(`users/permission-listing?group_id=${id}`);
}

export const rolePermissionAssign = async (data) => {
    return await post(`users/group-permission`,data);
}
